jQuery.feature_import("js-item-link",
  () => require("./ItemLink.js"),
  mod => mod.feature_js_item_link
);